import { Grid, Typography } from '@mui/material';
import { useAlertsStatus } from './hook';
import { AlertsProcessProps } from './props';
import { formatParams } from '../../../../../../shared/utils/params';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const AlertProcess = (props: AlertsProcessProps) => {
    const {
        formik,
        typeStatus,
        receptionChannels,
        typePQR,
        receivedThroughs,
        subtypeDps,
        transactions,
        hasNewStatus,
        typeNewStatus,
    } = useAlertsStatus(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Estados
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeStatus)}
                    label="Estado Inicial"
                    name="status"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            {hasNewStatus && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(typeNewStatus)}
                        label="Nuevo Estado"
                        name="newStatus"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.newStatus}
                        errors={formik.errors.newStatus}
                        value={formik.values.newStatus as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('newStatus', value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Proceso
                </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(receptionChannels)}
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionChannel', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(typePQR)}
                    label="Tipo PQR"
                    name="typePQR"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typePQR}
                    errors={formik.errors.typePQR}
                    value={formik.values.typePQR as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typePQR', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(receivedThroughs)}
                    label="Medio"
                    name="receivedThrough"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receivedThrough}
                    errors={formik.errors.receivedThrough}
                    value={formik.values.receivedThrough as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receivedThrough', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(subtypeDps)}
                    label="Subtipo DP"
                    name="subtypeDP"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subtypeDP}
                    errors={formik.errors.subtypeDP}
                    value={formik.values.subtypeDP as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('subtypeDP', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(transactions)}
                    label="Tramite"
                    name="transaction"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.transaction}
                    errors={formik.errors.transaction}
                    value={formik.values.transaction as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('transaction', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Detalles
                </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    errors={formik.errors.name}
                    value={formik.values.name as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observación"
                    name="observation"
                    size="small"
                    rows={2}
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation as string}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
